The identifier for the `PositionOpening` that this position profile belongs to.
